import * as Sentry from "@sentry/react";

export const initSentry = (): void => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    // Error Monitoring
    beforeSend(event) {
      // Filter out non-critical errors
      if (event.exception) {
        const error = event.exception.values?.[0];
        if (error?.type === 'ChunkLoadError' || 
            error?.type === 'Loading chunk') {
          return null; // Don't send chunk load errors
        }
      }
      return event;
    },
    // Don't send in development if no DSN is provided
    enabled: !!process.env.REACT_APP_SENTRY_DSN,
  });
};

// Helper function to capture custom errors
export const captureError = (error: Error, context?: Record<string, unknown>): void => {
  Sentry.captureException(error, {
    contexts: {
      custom: context,
    },
  });
};

// Helper function to add user context
export const setUserContext = (user: { id: string; email: string; role?: string }): void => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    role: user.role,
  });
};